import { Alert, Snackbar } from '@mui/material';
import React, { FC, useState } from 'react';

type severityType = 'success' | 'error' | 'warning';

type SnackbarProps = {
  message: string;
  open: boolean;
  handleClose: () => void;
  severity: severityType;
};

type useSnackBarProps = {
  onCloseFunc?: () => void;
};

export const useSnackbar = ({ onCloseFunc }: useSnackBarProps = {}) => {
  const [snackBarMsg, setSnackBarMsg] = useState<string>('');
  const [open, setOpen] = useState<boolean>(false);
  const [severity, setSeverty] = useState<severityType>('success');
  const handleClose = () => {
    setOpen(false);
    if (!!onCloseFunc) {
      onCloseFunc();
    }
  };

  const setWindowAlert = (message: string, severity: severityType) => {
    setOpen(true);
    setSnackBarMsg(message);
    setSeverty(severity);
  };

  return {
    CustomSnackbar: (
      <CustomSnackbar
        open={open}
        message={snackBarMsg}
        handleClose={handleClose}
        severity={severity}
      />
    ),
    setWindowAlert,
  };
};

const CustomSnackbar: FC<SnackbarProps> = ({ message, open, handleClose, severity }) => {
  const alertStyle = decideAlertStyle(severity);
  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={open}
        key="topcenter"
        onClose={handleClose}
        autoHideDuration={3000}
      >
        <Alert onClose={handleClose} style={alertStyle} variant="filled" severity={severity}>
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};

const decideAlertStyle = (severity: severityType) => {
  if (severity === 'success') {
    return {
      backgroundColor: 'green',
      color: 'white',
    };
  }
  if (severity === 'warning') {
    return {
      backgroundColor: 'rgb(245, 124, 0)',
      color: 'white',
    };
  }
  return {
    backgroundColor: 'rgb(211, 47, 47',
    color: 'white',
  };
};
